import React from 'react';

type ChildComponentProps = {
	key?: string;
	[key: string]: any;
};

interface IConditionalProps<C> {
	condition: any;
	component: React.ComponentType<C> | React.FunctionComponent<C>;
	componentProps: C;
}

/**
 * Conditionally renders a component with provided props
 */
export const Conditional = <T, >(props: IConditionalProps<T & ChildComponentProps>) => {
	const { condition, component: Component, componentProps } = props;

	let shouldRender = true;
	const isConditionNumber = typeof condition === 'number';

	if (isConditionNumber) {
		shouldRender = condition !== undefined;
	}
	if (!isConditionNumber) {
		shouldRender = !!condition;
	}

	// render nothing
	if (shouldRender === false) {
		return null;
	}

	// render passed component
	return <Component {...componentProps} />;
};
